import clsx from 'clsx';
import React from 'react';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import { PICTURE_CAPTION_CLASSES } from '../PictureCaption';
import { type ThemeViewsProps, getGatedContent } from '../interfaces';
import Content from './Content';

const Graphic = ({
  article,
  env,
  isWebview,
  midArticleUnitType,
  mostPopularArticles,
  newsletterId,
  relatedArticles,
  relatedEvent,
}: ThemeViewsProps) => {
  const {
    advertisement,
    authors,
    featuredGraphic,
    freeBlurb,
    highlight,
    id,
    pickups,
    picture,
    publishedAt,
    scriptList,
    subTitle,
    title,
  } = article;

  const { fullText, takeaway, addendum } = getGatedContent(article);

  return (
    <div className={clsx('px-16 sm:px-28', { 'pt-32 sm:pt-48': isWebview })}>
      <div className="relative m-auto max-w-container-lg">
        <div className="mb-24 flex flex-col items-center justify-between sm:mb-48 lg:mb-72">
          <div className="z-10 w-full flex-1">
            <Header highlight={highlight} title={title} subTitle={subTitle} />
          </div>
        </div>
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && article.access !== 'locked',
          })}
        >
          <div className="flex flex-col-reverse md:flex-row md:gap-72 xl:gap-112">
            <div className="flex-1">
              <div className="mb-40 sm:mb-48 md:mb-64">
                <ArticleDetails authors={authors} publishedAt={publishedAt} articleId={id} />
              </div>
            </div>
            <div
              className={clsx(
                PICTURE_CAPTION_CLASSES,
                'hidden lg:block lg:w-[260px] lg:flex-shrink-0'
              )}
            />
          </div>
          <Content
            access={article.access}
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            env={env}
            featuredGraphic={featuredGraphic}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            midArticleUnitType={midArticleUnitType}
            mostPopularArticles={mostPopularArticles}
            newsletterId={newsletterId}
            picture={picture}
            pickups={pickups}
            relatedArticles={relatedArticles}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            takeaway={takeaway}
          />
        </div>
      </div>
    </div>
  );
};

export default Graphic;
